import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IGuardarManiobras } from '../models/guardar_maniobras';
import { IEnviarTienda } from '../models/enviar_tienda';
import { IEnviarExtension } from '../models/enviar_extension';
import { IEnviarRescate } from '../models/enviar_rescate';
import { IDataEnviarGestion } from '../models/data_enviar_gestion';
import { IRescatePerc } from '../models/RescatePrec';
import { IEnviarExtensionFueraSemana } from '../models/enviar_extensio_fuera_semana';
import { IResultadoGeneral } from '../models/resultadogeneral';

@Injectable({
  providedIn: 'root'
})
export class ExtraService {

  private apiUrl: string ='';
  constructor(private http: HttpClient) { 
    this.apiUrl = environment.SUrlgApi + 'ServiciosExtra';
  }

  getListadoDeMovimientosFecha(fecha: string,fecha_fin: string,cod_usuario?:string): Observable<any[]> {
    let cod_usuario_cast = cod_usuario=='undefined' ? '': cod_usuario!; 
    const valores = {
      params: new HttpParams().
        set('fecha', fecha).
        set('fecha_fin', fecha_fin).
        set('cod_usuario', cod_usuario_cast)
    };
    return this.http
      .get<any[]>(this.apiUrl + '/GetListadoServiciosExtra', valores)
      .pipe(retry(1), catchError(this.handleError));
  }

  getEventoExiste(data:any):Observable<any>{
    return this.http.post<any>(this.apiUrl+'/ObtenerEventualidades/',data).pipe(retry(1), catchError(this.handleError));
  }

  ObtenerCalculoSueldos(data:any):Observable<any>{
    return this.http.post<any>(this.apiUrl+'/ObtenerCalcularSueldos/',data).pipe(retry(1), catchError(this.handleError));
  }

  getcalculoRuta(id_ruta:number,num_dias_extra:number,num_dias_estadia:number,fecha:string): Observable<any> {
    const valores = {
      params: new HttpParams().
        set('id_ruta', id_ruta).
        set('num_dias_extra', num_dias_extra).
        set('num_dias_estadia', num_dias_estadia).
        set('fecha',fecha)
    };
    return this.http
      .get<any>(this.apiUrl + '/calculoTabuladoExtRuta', valores)
      .pipe(retry(1), catchError(this.handleError));
  }

  deleteEventualidad(data:any):Observable<any>{
    const headers = { 'content-type': 'application/json'}  
    return this.http.post<any>(this.apiUrl+'/EliminarEventualidad/',data);
  }

  getEventosEventualidad():Observable<any[]>{
    return this.http.get<any[]>(this.apiUrl+'/GetEventosEventualidad').pipe(retry(1), catchError(this.handleError));
  }

  public agregarManiobras(data:IGuardarManiobras):Observable<any>{
    const headers = { 'content-type': 'application/json'}  
    const body = JSON.stringify(data); 
    return this.http.post<any>(this.apiUrl + '/SaveManiobras/',body,{'headers':headers});
   }

   public PostEventualidad(data:any):Observable<any>{
    const headers = { 'content-type': 'application/json'}  
    return this.http.post<any>(this.apiUrl+'/PostEventualidad/',data,{'headers':headers});
   }

   public agregarTiendasAdicionales(data:IEnviarTienda):Observable<any>{
    const headers = { 'content-type': 'application/json'}  
    const body = JSON.stringify(data); 
    return this.http.post<any>(this.apiUrl + '/SaveTiendaAdiconal/',body,{'headers':headers});
   }

   public agregarRescateUnidad(data:IEnviarRescate):Observable<any>{
    const headers = { 'content-type': 'application/json'}  
    const body = JSON.stringify(data); 
    return this.http.post<any>(this.apiUrl + '/SaveRescateUnidad/',body,{'headers':headers});
   }

   public agregarExtension(data:IEnviarExtension):Observable<any>{
    const headers = { 'content-type': 'application/json'}  
    const body = JSON.stringify(data); 
    return this.http.post<any>(this.apiUrl + '/SaveExtensionRuta/',body,{'headers':headers});
   }

   public agregarExtensionFueraSemana(data:IEnviarExtensionFueraSemana):Observable<any>{
    const headers = { 'content-type': 'application/json'}  
    const body = JSON.stringify(data); 
    return this.http.post<any>(this.apiUrl + '/SaveExtensionRutaFueraSemana/',body,{'headers':headers});
   }

   public agregarGestion(data:IDataEnviarGestion):Observable<any>{
    const headers = { 'content-type': 'application/json'}  
    const body = JSON.stringify(data); 
    return this.http.post<any>(this.apiUrl + '/SaveGestionRuta/',body,{'headers':headers});
   }

  public getListadoRescatePercent(): Observable<IRescatePerc[]> {
    return this.http
      .get<IRescatePerc[]>(this.apiUrl+'/GetListRescatePercent')
      .pipe(retry(1), catchError(this.handleError));
  }

  public earseExtension(idx:number,cod_usuario:string,id_ruta:number,num_operacion:number,fecha:string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let data = {
        idx: idx,
        cod_usuario: cod_usuario,
        id_ruta: id_ruta,
        num_operacion: num_operacion,
        fecha: fecha
    };
    let data_enviar={headers:headers, body : JSON.stringify(data)};

    return this.http
      .delete<IResultadoGeneral>(this.apiUrl + '/EliminarExt', data_enviar)
      .pipe(retry(1), catchError(this.handleError));
  }

  handleError(error:any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
        return errorMessage;
    });
  }


}
